module.exports = __webpack_public_path__ + "img/yellow-earbuds.2f5885d9.jpg";